import { FC } from "react";
import { AutoModel, PointsLedgerModal, PointsPurchaseModal } from "../../components/common";
import { useShellActions } from "../../components/common/ShellActionsContext";
import { useShellCredits } from "../../components/common/ShellCreditsContext";
import { useShellNotifications } from "../../components/common/ShellNotificationsContext";
import { PERMISSIONS } from "../../constants/permissionKeys";
import { useHasPermission } from "../../hooks/useHasPermission";

/**
 * 侧栏新增的积分/通知入口对应的弹窗集中 owner：
 * 积分明细、积分充值、通知收件箱三个 AutoModel 均在此渲染，避免各处各持一份。
 * 必须在 ShellActionsProvider / ShellNotificationsProvider 内渲染。
 * 无对应权限时（含权限未就绪）不渲染弹窗。
 */
export const ShellModals: FC = () => {
  const actions = useShellActions();
  const credits = useShellCredits();
  const notifications = useShellNotifications();
  const hasPoints = useHasPermission(PERMISSIONS.POINTS_VIEW);
  const hasNotify = useHasPermission(PERMISSIONS.NOTIFICATION_VIEW);

  const showPointsModals = hasPoints === true && actions;
  const showNotifyModal = hasNotify === true && notifications;

  const availablePoints = credits?.hidden
    ? 0
    : Number((credits?.creditsText ?? "0").replace(/[^\d]/g, "")) || 0;

  return (
    <>
      {showPointsModals ? (
        <>
          <PointsLedgerModal
            open={actions.showPointsDetail}
            onClose={actions.closePointsDetail}
            availablePoints={availablePoints}
            isPaid
          />

          <AutoModel
            open={actions.showPurchase}
            onClose={actions.closePurchase}
            title="积分充值"
            contentMaxWidth={700}
            contentClassName="points-purchase-modal-shell"
            overlayClassName="points-purchase-modal-overlay"
          >
            <PointsPurchaseModal
            open={actions.showPurchase}
            onClose={actions.closePurchase}
            isBasicMember
          />
          </AutoModel>
        </>
      ) : null}

      {showNotifyModal ? (
        <AutoModel
          open={notifications.inboxOpen}
          onClose={notifications.closeInbox}
          title={notifications.inboxTitle}
          contentMaxWidth={925}
          contentClassName="notification-modal"
          overlayClassName="notification-modal-overlay"
        >
          {notifications.renderInboxContent()}
        </AutoModel>
      ) : null}
    </>
  );
};
